import { Component, EventEmitter, Input, Output, OnDestroy } from '@angular/core';

@Component({
  selector: 'app-student-majors-card',
  templateUrl: './student-majors-card.component.html',
  styleUrls: ['./student-majors-card.component.scss']
})
export class StudentMajorsCardComponent implements OnDestroy{

  @Input() majors: any;
  @Input() careers: any;
  @Input() selectedMajors: any;
  @Input() selectedCareers: any;

  careerModel;
  majorModel;
  formsTouched = false;

  getCareerMajorList() {
    return { careerList: this.selectedCareers, majorList: this.selectedMajors };
  }

  myListFormatter(data: any): string {
    return data.text;
  }

  myValueFormatter(data: any): string {
    return data.text;
  }

  careerSelected(event) {
    this.formsTouched = true;
    if (!this.selectedCareers.includes(event.id)) {
      this.selectedCareers.push(event.id);
    }

    setTimeout(() => {
      this.careerModel = null;
    }, 100)

  }

  majorSelected(event) {
    this.formsTouched = true;
    if (!this.selectedMajors.includes(event.id)) {
      this.selectedMajors.push(event.id);
    }

    setTimeout(() => {
      this.majorModel = null;
    }, 100)

  }

  getNameByid(data, id) {
    for (let i = 0; i < data.length; i++) {
      if (data[i].id === id) {
        return data[i].text;
      }
    }
  }
  ngOnDestroy() {
    this.formsTouched = false;
  }

}
